import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import contentOutputs from '../editorCapabilities/ContentOutputTypes';
import ContentTypeaheadContainer from '../components/insertMenu/ContentTypeAheadContainer';
import GenericPopoverHeader from '../components/GenericPopoverHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TypeaheadInserterRenderer({
  onInsert,
  onDismiss,
  portalId,
  contactEmail,
  contactVid,
  supplementalObjects,
  search,
  fetchRenderedContent,
  transformData,
  outputType,
  EmptyState,
  ErrorState,
  Header = GenericPopoverHeader,
  searchPlaceholder,
  titleMessage,
  manageUrl,
  getNewLinkUrl,
  contentKey,
  CustomItemComponent,
  onTrackSelection,
  onClickManageButton,
  onSearchChange
}) {
  const handleChange = useCallback(({
    id,
    htmlBody,
    version
  }) => {
    onTrackSelection === null || onTrackSelection === void 0 || onTrackSelection();
    if (outputType === contentOutputs.EDITABLE || !fetchRenderedContent) {
      if (typeof htmlBody === 'string') {
        onInsert({
          htmlBody
        });
      }
      return;
    }
    fetchRenderedContent({
      id,
      version,
      contactEmail,
      contactVid,
      supplementalObjects
    }).then(response => {
      const resolvedHtml = outputType === contentOutputs.RENDERED ? response.htmlBody : response.body;
      onInsert({
        htmlBody: resolvedHtml,
        metadata: response.metadata
      });
    }).catch(error => {
      Raven.captureException(error);
    });
  }, [outputType, fetchRenderedContent, contactEmail, contactVid, supplementalObjects, onInsert, onTrackSelection]);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      minHeight: 322
    },
    "data-test-id": "content-popover-container",
    children: [/*#__PURE__*/_jsx(Header, {
      portalId: portalId,
      onClickManageButton: onClickManageButton,
      onViewInsertMenu: onDismiss,
      manageUrl: manageUrl,
      titleMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: titleMessage
      }),
      getNewLinkUrl: getNewLinkUrl
    }), /*#__PURE__*/_jsx(ContentTypeaheadContainer, {
      ErrorState: ErrorState,
      EmptyState: EmptyState,
      onChange: handleChange,
      onSearchChange: onSearchChange,
      portalId: portalId,
      search: search,
      transformData: transformData,
      searchPlaceHolder: searchPlaceholder,
      CustomItemComponent: CustomItemComponent,
      contentKey: contentKey
    })]
  });
}